import React from 'react';
import IconWrapper from '../../../IconWrapper';
const AccountDefaultIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { d: "M10.188 7.849a4 4 0 1 0-4.376 0A7.008 7.008 0 0 0 1 14.5v1h2v-1a5 5 0 1 1 10 0v1h2v-1a7.002 7.002 0 0 0-4.812-6.651ZM10 4.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
export default AccountDefaultIconSmall;
//# sourceMappingURL=AccountDefaultIconSmall.js.map